import React from 'react';
import PropTypes from 'prop-types';

function FormInput({
  label,
  placeholder,
  className = '',
  inputClassName = '',
  error,
  ...rest
}) {
  return (
    <div className={`flex flex-col flex-1 min-w-0 ${className}`}>
      <label className="sr-only">{label}</label>
      <div
        className={`flex items-center h-[52px] rounded-xl bg-zinc-800/90 px-4 transition-shadow focus-within:ring-2 focus-within:ring-orange-500/50 ${
          error ? 'ring-2 ring-red-500/40' : ''
        }`}
      >
        <input
          type="tel"
          inputMode="numeric"
          placeholder={placeholder}
          className={`w-full bg-transparent text-white placeholder:text-white/40 outline-none text-base ${inputClassName}`}
          aria-label={label}
          aria-invalid={Boolean(error)}
          {...rest}
        />
      </div>
    </div>
  );
}

FormInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  error: PropTypes.string,
};

export default FormInput;
